// extracted by mini-css-extract-plugin
export default {"builder_wrapper":"Register_builder_wrapper__x3xep"};